import { t } from 'i18next';
import * as yup from 'yup';

export const updateDescriptionSchema = () =>
  yup.object().shape({
    description: yup.string().nullable().label(t('labelDescription')).required(),
  });
